import {BRONZE, ORANGE, SILVER} from 'top20common/distribution/constants/tokens';

import {STATUS_HIRED, STATUS_INTERVIEW, STATUS_QUALIFIED} from './referrals';

export const TOKENS_TO_STATUS = {
  [BRONZE]: STATUS_QUALIFIED,
  [SILVER]: STATUS_INTERVIEW,
  [ORANGE]: STATUS_HIRED
};
